import { Injectable } from '@angular/core';
import { EAuthTokenType } from '../enums/types';

declare const CryptoJS: any;

@Injectable({
    providedIn: 'root',
})
export class UtilsService {

    constructor() {
    }

    authTokenAM = {
        u: 'default',
        p: 'default',
    };

    public generateMongoObjectId() {
        const timestamp = (new Date().getTime() / 1000 | 0).toString(16);
        return timestamp + 'xxxxxxxxxxxxxxxx'.replace(/[x]/g, () => {
            return (Math.random() * 16 | 0).toString(16);
        }).toLowerCase();
    }

    characters = 'abcdefghijklmnopqrstuvwxyz0123456789_ABCDEFGHIJKLMNOPQRSTUVWXYZ';

    public getRandomString(size: number) {
        let result = '';
        const charactersLength = this.characters.length;
        for (let i = 0; i < size; i++) result += this.characters.charAt(Math.floor(Math.random() * charactersLength));
        return result;
    }

    getEncryptedString(obj: any, p: string) {
        try {
            if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'number') return CryptoJS.AES.encrypt(obj, p).toString();
            else return CryptoJS.AES.encrypt(JSON.stringify(obj), p).toString();
        } catch (e) {
            console.log(e);
        }
    }

    public getDecryptedObject(encryptedStr: string, p: string) {
        let obj;
        try {
            const decrypted = CryptoJS.AES.decrypt(encryptedStr, p);
            const decryptedStr = decrypted.toString(CryptoJS.enc.Utf8);
            if (decryptedStr) obj = JSON.parse(decryptedStr);
        } catch (e) {
            console.log(e);
        }
        return obj;
    }

    public getDecryptedString(encryptedStr: string, p: string) {
        const decrypted = CryptoJS.AES.decrypt(encryptedStr, p);
        try {
            return decrypted.toString(CryptoJS.enc.Utf8);
        } catch (e) {
            console.log(e);
        }
    }


    truncateDecimals(num: number, digits: number) {
        if (num) {
            let numS = num.toString(),
                decPos = numS.indexOf('.'),
                substrLength = decPos === -1 ? numS.length : 1 + decPos + digits,
                trimmedResult = numS.substr(0, substrLength),
                finalResult = isNaN(<any>trimmedResult) ? 0 : trimmedResult;

            return parseFloat(<any>finalResult);
        }
        return 0;
    }

    /**
     * It will combine CSV file data.
     * It will take first line (header line) only from first file, it will ignore first line from other files.
     * @param files
     */
    public async getFileContentFromFiles(files: File[]): Promise<string> {
        let lines: string[] = [];
        let first = true;
        for (const file of files) {
            const content = await this.getFileContentFromFile(file);
            const linesTemp = content.split('\n');

            if (first) lines.push(...linesTemp);
            else {
                linesTemp.shift(); // remove header from 2nd, 3rd files.
                lines.push(...linesTemp);
            }
            first = false;
        }
        return lines.join('\n');
    }

    public getFileContentFromFile(file: File): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsText(file, "UTF-8");
            reader.onload = function (evt: any) {
                resolve(evt.target.result);
            };
            reader.onerror = function (evt) {
                reject(new Error('Unable to read file.'));
            };
        });
    }

    isSame(f1: number, f2: number) {
        return Math.abs(f1 - f2) < 0.001;
    }

    public toAmPmTrips(what: any) {
        if (!what) {
            return ' ';
        }
        if (what.length === 0) {
            return ' ';
        }
        if (what !== null) {
            if (what.toLowerCase() !== 'call' && what.length > 0) {
                if (what.indexOf(':') < 0) {
                    what = what.substring(0, 2) + ':' + what.substring(2, 4);
                }
                // console.log(what);
                let ap = 'am';
                const arr = what.split(':');
                let h = parseInt(arr[0]);
                if (h > 11) {
                    ap = 'pm';
                }
                if (h > 12) {
                    h = h - 12;
                }
                if (h === 0) {
                    h = 12;
                }
                return h.toString().concat(':').concat(arr[1]).concat(ap);
            } else {
                return what;
            }
        } else {
            return '';
        }
    }

    validateMobileNumber(e: any) {
        if (e.key === "Tab") return;
        if (isNaN(e.key) && e.key !== 'Backspace' && e.key !== 'ArrowLeft' && e.key !== 'ArrowRight' && e.key !== 'Delete') e.preventDefault();
        if (e.key === " ") e.preventDefault();
    }

    validatePinNumber(e: any) {
        if (e.key === "Tab") return;
        if (isNaN(e.key) && e.key !== 'Backspace' && e.key !== 'ArrowLeft' && e.key !== 'ArrowRight' && e.key !== 'Delete') e.preventDefault();
        if (e.key === " ") e.preventDefault();
        this.pinNumberBoxes();
    }

    pinNumberBoxes() {
        let otp = document.querySelectorAll('.pin');
        if (otp[0]) {
            otp.forEach(el => {
                el.addEventListener('focus', (e) => { // @ts-ignore
                    el.select();
                });
                el.addEventListener('input', (e: any) => {
                    if (e.target.value === 'undefined' || e.target.value === '') {
                        // @ts-ignore
                        el.previousSibling ? el.previousSibling.focus() : el.blur();
                        return;
                    }
                    // @ts-ignore
                    el.nextElementSibling ? el.nextElementSibling.focus() : el.blur();
                    // @ts-ignore
                    this.setPinValue(el.id, document.getElementById(el.id).value);
                    setTimeout(() => {
                        // @ts-ignore
                        document.getElementById(el.id).value = "•";
                    }, 100);
                });
            });
        }
    }

    public userPin: any = [
        { id: 'pinCount1', value: '' },
        { id: 'pinCount2', value: '' },
        { id: 'pinCount3', value: '' },
        { id: 'pinCount4', value: '' },
        { id: 'pinCount5', value: '' },
        { id: 'pinCount6', value: '' }
    ];

    setPinValue(id: string, value: string) {
        for (let item of this.userPin) {
            if (item.id === id) {
                item.value = value;
            }
        }
    }
}
